import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';

// The node BV attaches to during swat_reviews 'show'. It has to be committed
// inside the show handler's flushSync, so it lives outside the deferred chunk.
const BVReviewsHost = t0 => {
  const $ = _c(3);
  const {
    productId,
    hostRef: t1
  } = t0;
  const hostRef = t1 === undefined ? null : t1;
  if (!productId) {
    return null;
  }
  let t2;
  if ($[0] !== hostRef || $[1] !== productId) {
    t2 = <div ref={hostRef} data-bv-show="reviews" data-bv-product-id={productId} />;
    $[0] = hostRef;
    $[1] = productId;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
BVReviewsHost.propTypes = {
  productId: PropTypes.string,
  hostRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })])
};
export default BVReviewsHost;